import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Theme from '../common/NekoTheme';
import { ProOnly } from '../label/ProOnly';

const TabContainer = Styled.div`
`;

const TabGroup = Styled.div`
`;

const Tab = Styled.button`
  font-family: ${Theme.fontFamily};
  font-size: ${Theme.fontSizeText};
  background-color: ${Theme.gray};
  border-radius: 8px 8px 0px 0px;
  border: 0;
  color: ${Theme.darkGray};
  cursor: pointer;
  line-height: 17px;
  margin-right: 5px;
  text-align: left;
  padding: 10px 15px 10px 15px;

  &:focus {
    outline: none;
  }

  &.active {
    background-color: ${Theme.blue};
    color: ${Theme.white};
  }

  &.disabled {
    background-color: rgba(${Theme.yellowRGB}, 0.25);
    cursor: default;
  }
`;

const TabContent = Styled.div`
  background-color: ${Theme.blue};
  display: none;
  padding: 10px;

  &.active {
    display: block;
  }
`;

/**
 * Need to use with NecoTab
 */
const StyledNekoTabs = props => {

  const [isActiveTabIndex, setIsActiveTabIndex] = React.useState(0);

  const tabAttributes = React.Children.map(props.children, (child, i) => {
    const title = child.props.title || ("Untitled Tab " + (i + 1));
    const key = child.props.key || 'neko-tab-' + title.toLowerCase();
    const onClick = child.props.onClick ? child.props.onClick : null;
    const requirePro = !props.isPro && (child.props.requirePro || false);
    return { key, title, onClick, requirePro };
  });

  const children = React.Children.map(props.children, (child, i) => {
    return React.cloneElement(child, {
      isActive: i === isActiveTabIndex
    });
  });

  const onTabClick = (tabIndex, tabAttr, ev) => {
    if (tabAttr.requirePro) return;
    setIsActiveTabIndex(tabIndex);
    if (props.onChange) {
      props.onChange(tabIndex, tabAttr, ev);
    }
  }

  return (
    <TabContainer>
      <TabGroup>
        {tabAttributes.map((attr, i) =>
          <Tab 
            key={attr.key} 
            className={`neko-tab-title ${i === isActiveTabIndex ? 'active' : ''} ${attr.requirePro ? 'disabled' : ''}`} 
            onClick={(ev) => { onTabClick(i, attr, ev) }} >
            {attr.title}<ProOnly className="inline" style={{ marginLeft: 10, marginRight: -5, top: -1 }} show={attr.requirePro} />
          </Tab>
        )}
      </TabGroup>
      { children }
    </TabContainer>
  );
};


/**
 * @oaram {string} title
 * @param {bool} isActive
 */
const StyledNekoTab = props => {

  const { children, isActive } = props;

  return (
    <TabContent className={`${isActive ? 'active' : ''}`}>
      { children }
    </TabContent>
  );
};

const NekoTabs = (props) => {
  return (<StyledNekoTabs {...props} />);
}

NekoTabs.propTypes = {
  isPro: PropTypes.bool,
  onChange: PropTypes.func
};

NekoTabs.defaultProps = {
  isPro: false,
  onChange: undefined
};

const NekoTab = (props) => {
  return (<StyledNekoTab {...props} />);
}

NekoTab.propTypes = {
  isActive: PropTypes.bool,
  requirePro: PropTypes.bool,
  title: PropTypes.string
}

NekoTab.defaultProps = {
  isActive: false,
  requirePro: false,
  title: undefined
}

export { NekoTab, NekoTabs };
